import { dateToLocaleString } from '../../../utils/common';
import PropTypes from 'prop-types';

const PromoBanner = ({ info = {} }) => {
  const { rangeDate = {}, description = '', future = false } = info;

  return (
    <div className="border w-full border-orange-400 bg-gradient-to-tr from-orange-50 to-orange-100  flex flex-row items-center gap-3 rounded-xl shadow-sm px-4 py-3 text-sm">
      {/* <p>⚡</p>*/}
      <div className="flex flex-col min-w-0">
        {future && (
          <span className="text-xs text-primary font-semibold">Próximamente</span>
        )}
        {/* <span className="font-semibold text-gray-800 leading-tight">Bono activo</span>*/}
        <span className="text-[10px] text-gray-500 leading-tight">
          {dateToLocaleString(rangeDate.init, rangeDate.end)}
        </span>
        <span className="text-xs text-gray-500 leading-tight">
          {description}
        </span>
      </div>
    </div>
  );
};

PromoBanner.propTypes = {
  info: PropTypes.shape({
    rangeDate: PropTypes.shape({
      init: PropTypes.string,
      end: PropTypes.string,
    }),
    title: PropTypes.string,
    description: PropTypes.string,
    future: PropTypes.bool,
  }),
};

export default PromoBanner;
